import { render, staticRenderFns } from "./FlightItem.vue?vue&type=template&id=ae503212&scoped=true&"
import script from "./FlightItem.vue?vue&type=script&lang=js&"
export * from "./FlightItem.vue?vue&type=script&lang=js&"
import style0 from "./FlightItem.vue?vue&type=style&index=0&id=ae503212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae503212",
  null
  
)

export default component.exports